/**
 * Client auth-mode flag (B2C client phase 2). `VITE_AUTH_MODE` selects how the client
 * authenticates to the API: `basic` (the V1 bundled basic-auth credential, DEFAULT) or
 * `b2c` (Azure AD B2C via MSAL). The default is `basic` so the current UI and ALL existing
 * client tests keep working until the Phase 3 cutover flips this to `b2c`.
 *
 * Read via a function (not a module constant) so it is evaluated at call time — that lets
 * tests stub `import.meta.env.VITE_AUTH_MODE` per-case with `vi.stubEnv`. MSAL is only ever
 * imported/initialized when this returns `b2c`, so basic mode never touches MSAL.
 */
export type AuthMode = "basic" | "b2c";

export function getAuthMode(): AuthMode {
  const raw = (import.meta.env.VITE_AUTH_MODE ?? "basic").toString().trim().toLowerCase();
  return raw === "b2c" ? "b2c" : "basic";
}

export function isB2cMode(): boolean {
  return getAuthMode() === "b2c";
}
